import { appRoutes } from "../Components/UserModule/userRoutes";

export const getAllowedRoutes = (permissions) => {
  const routes = appRoutes(); // ✅ call function here
  return permissions.map((key) => routes[key]).filter(Boolean);
};
